import { defineComponent as _defineComponent } from 'vue';
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, unref as _unref, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = { class: "px-5 pt-6 pb-4 bg-white" };
const _hoisted_2 = { class: "max-w-270 mx-auto" };
const _hoisted_3 = { class: "mb-6 sm:mb-8" };
const _hoisted_4 = { class: "text-2xl sm:text-3xl font-bold text-gray-900 mb-2" };
const _hoisted_5 = { class: "text-base sm:text-lg font-semibold text-gray-900 mb-3" };
const _hoisted_6 = { class: "text-sm text-darkgray mb-6" };
import { onMounted } from "vue";
import { useI18n } from "vue-i18n";
import { Button, useToast } from "@eudonet/opal";
import { keycloakPasswordService } from "@/infrastructure/adapters/KeycloakPasswordService";
import { logger } from "@/infrastructure/services/LoggerService";
const TOAST_DURATION_MS = 5000;
export default /*@__PURE__*/ _defineComponent({
    __name: 'SecuritySettings',
    setup(__props) {
        const { showToast } = useToast();
        // Use the interface type for clean architecture (with clearPasswordChangeFlag support)
        const passwordService = keycloakPasswordService;
        const { t, locale } = useI18n();
        /**
         * Handles the password reset button click.
         * Delegates to the password service interface for clean separation of concerns.
         */
        const handleResetPassword = async () => {
            try {
                // Delegate to password service via interface
                // Analytics tracking is handled internally by the service
                await passwordService.initiatePasswordChange({
                    redirectUri: `${window.location.origin}/profile/security`,
                    locale: mapLocaleForKeycloak(locale.value),
                });
            }
            catch (error) {
                logger.debug("Password change failed:", error);
            }
        };
        /**
         * Maps i18n locale to Keycloak locale format.
         */
        function mapLocaleForKeycloak(appLocale) {
            if (appLocale.startsWith("fr"))
                return "fr";
            if (appLocale.startsWith("nl"))
                return "nl";
            return "en";
        }
        /**
         * Checks if the user is returning from a password change flow
         * and shows a success toast if so.
         */
        function checkPasswordChangeSuccess() {
            if (passwordService.wasPasswordChangeInitiated()) {
                showToast({
                    message: t("security.passwordUpdate.successMessage"),
                    ariaClose: t("security.passwordUpdate.dismissToast"),
                    status: "success",
                    duration: TOAST_DURATION_MS,
                });
                // Clear the flag after showing the toast
                passwordService.clearPasswordChangeFlag();
                logger.debug("Password change completed successfully");
            }
        }
        onMounted(() => {
            checkPasswordChangeSuccess();
        });
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("div", _hoisted_1, [
                _createElementVNode("div", _hoisted_2, [
                    _createElementVNode("div", _hoisted_3, [
                        _createElementVNode("h1", _hoisted_4, _toDisplayString(_ctx.$t("security.title")), 1 /* TEXT */)
                    ]),
                    _createElementVNode("div", null, [
                        _createElementVNode("h2", _hoisted_5, _toDisplayString(_ctx.$t("security.passwordUpdate.title")), 1 /* TEXT */),
                        _createElementVNode("p", _hoisted_6, _toDisplayString(_ctx.$t("security.passwordUpdate.description")), 1 /* TEXT */),
                        _createVNode(_unref(Button), {
                            variant: "primary",
                            label: _ctx.$t('security.passwordUpdate.resetButton'),
                            onClick: handleResetPassword
                        }, null, 8 /* PROPS */, ["label"])
                    ])
                ])
            ]));
        };
    }
});
